
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  components: { VueSlickCarousel },

  data() {
    return {
      imageSettings: {
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        dots: false,
      },
      attributes:['att_broj-osoba_numberField','att_broj-kreveta_numberField','att_broj-kupaonica_numberField','att_broj-spavacih-soba_numberField'],
      attributeLabels:{
        'att_broj-osoba_numberField':'Broj osoba',
        'att_broj-spavacih-soba_numberField':'Broj spavaćih soba',
        'att_broj-kreveta_numberField':'Broj kreveta',
        'att_broj-kupaonica_numberField':'Broj kupaonica'
      }
    };
  },

  mounted() {
  },

  props: {
    product: {
      type: [Array, Object],
      required: true,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
};
